export const UI_MESSAGES = {
  LOADING: "Loading...",
  ERROR_LOADING_DATA: "Error loading data.",
  ERROR_PAGE_NOT_FOUND: "Error Page Not Found",
  SELECT_TYPE_PROMPT: "Please select a Type",
  TOKEN_EXCHANGE_FAILED: "Token exchange failed:",
  FAILED_GET_ID_TOKEN: "Failed to get ID token",
  COULD_NOT_STORE_TOKEN: "Could not store auth0_raw_token",
  SESSION_EXPIRED: "Session expired. Please login again.",
  NO_PERMISSION: "You do not have permission to perform this action.",
  NETWORK_ERROR: "Network error. Please check your connection.",
  QUERY_CANCELLED: "Query was cancelled",
  SENDING: "Processing...",
  ENTER_CONTACT_INFO: "Please enter your phone number or email address to start chatting.",
  ENTER_MESSAGE: "Type your message here...",
  SEND_MESSAGE: "Send Message",
  START_CHAT: "Start Chat",
  PHONE_OR_EMAIL_REQUIRED: "Please enter either a phone number or email address.",
  MESSAGE_REQUIRED: "Please enter a message.",
  INVALID_EMAIL: "Please enter a valid email address.",
  INVALID_PHONE: "Please enter a valid phone number.",
  ADD_NEW_QUESTION: "Add New Question",
  NEW_QUESTION_ADDED: "New question added",
  QUESTION_DELETED: "Question deleted successfully",
  ENTER_QUESTION_TEXT: "Enter your question here...",
  UPDATING: "Updating...",
  UPDATE_PRESCREENING_DETAILS: "Update Prescreening Details",
  PRESCREENING_UPDATED: "Prescreening details updated successfully!",
  PRESCREENING_UPDATE_FAILED: "Failed to update prescreening details",
  ACCESS_DENIED: "You do not have access to the Engage AI application, please contact the Engage AI admin team for more details",
  // Campaign-specific messages
  CAMPAIGN_CREATED: "Campaign created successfully!",
  CAMPAIGN_UPDATED: "Campaign updated successfully!",
  ERROR_CREATING_CAMPAIGN: "Error creating campaign",
  ERROR_UPDATING_CAMPAIGN: "Error updating campaign",
} as const;

